import { useLocation } from 'react-router-dom';
import { getJourneyBackTo } from '@/lib/journey-back';
import ScreenBackButton from './ScreenBackButton';

/** Back control for fixed steps in the entrepreneur journey (map → questionnaire → …). */
export default function JourneyScreenBack() {
  const { pathname } = useLocation();
  const to = getJourneyBackTo(pathname);
  if (!to) return null;
  return <ScreenBackButton to={to} />;
}
